import { gql } from '@apollo/client';

export const CREATE_PROJECT = gql`
  mutation CreateProject($project: CreateProjectInput!, $vendorId: ID!) {
    createProject(project: $project, vendorId: $vendorId) {
      firstName
      id
      createdAt
      connected
      createdBy
      vendorProjectOwnerEmail
      type
      status
      name
      mqttEndpoint
      lastName
    }
  }
`;
